<div class="tw-flex tw-h-full tw-min-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-bg-gray-100 tw-px-4 tw-py-10 sm:tw-gap-8 sm:tw-px-6 sm:tw-py-12">
  <div class="tw-flex tw-w-full tw-max-w-[636px] tw-flex-col tw-items-center tw-gap-6 sm:tw-gap-8">
    <div class="tw-w-full tw-shrink-0 tw-text-center tw-max-w-[279px] md:tw-max-w-[400px]">
      <img
        class="tw-mx-auto tw-h-full tw-w-full"
        src="assets/images/database/empty-state-no-persona-illustration.png"
        width="400"
        height="300"
        alt="People reviewing charts and dashboards"
        loading="lazy"
        decoding="async"
      />
    </div>

    <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-2 tw-text-center">
      <h2 class="tw-text-base tw-font-bold tw-leading-snug tw-text-gray-900 md:tw-text-xl">Create attendee personas to unlock event insights</h2>
      <p class="tw-text-sm tw-leading-5 tw-text-gray-500 sm:tw-leading-6 sm:tw-text-base">
        Create personas to start tracking registrations, engagement, and attendee insights across your event.
      </p>
    </div>

    <button
      type="button"
      class="tw-flex tw-w-full tw-max-w-xs tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-blue-600 tw-px-5 tw-py-3 tw-text-sm tw-font-medium tw-text-white tw-transition-colors hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2 focus:tw-ring-offset-gray-100 sm:tw-w-auto sm:tw-max-w-none sm:tw-px-6 sm:tw-text-base"
      [ngClass]="{ '!tw-cursor-not-allowed': !canCreatePersona() }"
      (click)="onCreatePersonaClick()"
    >
      <svg class="tw-h-5 tw-w-5 tw-shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M12 5v14M5 12h14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>Create first persona</span>
    </button>
  </div>
</div>

@if (isModalOpened(createPersonaModalId)) {
  <create-persona-modal
    [id]="createPersonaModalId"
    [isSubmitting]="isCreatingPersona()"
    [apiErrorBody]="createPersonaApiError()"
    (onCreate)="onCreatePersonaSubmitted($event)"
    (onCancel)="cancelCreatePersonaModal()"
  ></create-persona-modal>
}
